/* eslint-disable react/button-has-type */
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setCategory,
  setDefaultFilters,
  setProviderFilter,
  setProviderPage,
  searchGamesChange,
} from "redux/game/slice";
import {
  NAVIGATION_PROPERTIES,
  TopNavigationDesktopTypes,
  TOP_NAVIGATION_DESKTOP_ID_ENUM,
} from "constants/navigation/topNavigationDesktop";
import { makeLangUrl } from "helpers/makeLangUrl";
import { isUrlActive, isUrlInclude } from "helpers/is";
import useTranslate from "hooks/useTranslate";
import { useGTM } from "hooks/useGTM";
import { useCheckBalance } from "hooks/useCheckBalance";
import * as userSelectors from "redux/user/selectors";
import { useRouterHistoryStore } from "stores/routerHistory";
import url from "url/index";

import "./styles.sass";
import { CATEGORIES_ENUMS } from "constants/navigation/categories";

export type TopNavigationDesktopItemProps = {
  data: TopNavigationDesktopTypes;
};

const TopNavigationDesktopItem = (props: TopNavigationDesktopItemProps) => {
  const {
    id,
    link,
    name = "",
    nameImage,
    label,
    urlAlias,
    property,
    value,
    // eslint-disable-next-line react/destructuring-assignment
  } = props.data;

  const t = useTranslate();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const checkBalance = useCheckBalance();
  const userId = useSelector(userSelectors.id);
  const GTM = useGTM();
  const setPreviousPage = useRouterHistoryStore(
    (state) => state.setPreviousPage,
  );

  const handleClick = () => {
    if (id === TOP_NAVIGATION_DESKTOP_ID_ENUM.CASINO) {
      // eslint-disable-next-line no-unused-expressions
      userId ? GTM.openMainPage(userId) : GTM.openMainPage(0);
      dispatch(setDefaultFilters());
    }
    if (id === TOP_NAVIGATION_DESKTOP_ID_ENUM.LIVE_CASINO) {
      dispatch(setProviderFilter(null));
      GTM.clickLiveCasinoDesktop();
      dispatch(setCategory(CATEGORIES_ENUMS.LIVE_CASINO));
      dispatch(searchGamesChange(""));
    }
    if (id === TOP_NAVIGATION_DESKTOP_ID_ENUM.V_SPORT) {
      GTM.clickVSport();
    }
    if (id === TOP_NAVIGATION_DESKTOP_ID_ENUM.TOURNAMENTS) {
      GTM.clickTournaments();
      dispatch(setDefaultFilters());
    }
    if (id === TOP_NAVIGATION_DESKTOP_ID_ENUM.AVIATOR) {
      GTM.clickAviator();
      const isBalancePositive = checkBalance();
      if (isBalancePositive) {
        navigate({
          pathname: makeLangUrl(
            url.routes.casino.game({
              game: urlAlias,
            }),
          ),
        });
      }
    }
    if (id === TOP_NAVIGATION_DESKTOP_ID_ENUM.GAMES) {
      dispatch(setDefaultFilters());
      dispatch(setProviderFilter(value?.[0] || null));
    }
    if (link) {
      navigate(makeLangUrl(link));
    }
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (property) {
      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (property === NAVIGATION_PROPERTIES.PROVIDER) {
        if (value) {
          dispatch(setDefaultFilters());
          dispatch(setProviderFilter(null));
          dispatch(setProviderPage(value.join(",")));
        }
      }
    }
    setPreviousPage(`${location.pathname}${location.search}`);
  };

  const navigationClass = classNames("TopNavigationDesktopItem", {
    active: id === 0 ? isUrlActive(link) : isUrlInclude(link),
  });

  return (
    <button className={navigationClass} onClick={handleClick}>
      {nameImage || t(name)}
      <div className="TopNavigationDesktopItem__label">{label}</div>
    </button>
  );
};

export default TopNavigationDesktopItem;
